import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { verifyClaims } from '../utils/canActivateRoute';
@Injectable({
    providedIn: 'root'
})
export class ApproverOnlyGuard  {
    constructor(private authService: AuthService, private router: Router) { }
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const activated = verifyClaims(childRoute, this.authService);
        if(activated == false)
        {
            this.router.navigate(['/'], {
                queryParams: { returnUrl: state.url }
            });
        }

        return activated;
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const activated = verifyClaims(route, this.authService);
        if(activated == false)
        {
            this.router.navigate(['/'], {
                queryParams: { returnUrl: state.url }
            });
        }
        return activated;
    }


}